import { ProjectManager } from "../twig/components/Project";
import { FrontPage } from "../twig/pages/front-page";
import { LazyLoader } from '../../views/ts/components/LazyLoader';
import { Inventory } from "../twig/pages/template-inventory";
import { Masks } from "../twig/components/Masks";
import { Header } from "../twig/components/Header";
import { Page } from "../twig/pages/page";
import { Navigator } from "./components/Navigator";
(new LazyLoader()).init();
new Header().init();
new ProjectManager().init();
new FrontPage().init();
new Inventory().init();
new Page().init();
new Masks().init();
new Navigator().init();
